import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiContentService } from '../../api/api-content.service';

@Component({
  selector: 'app-notifikasi',
  templateUrl: './notifikasi.component.html',
  styleUrls: ['./notifikasi.component.css']
})
export class NotifikasiComponent implements OnInit {

  constructor(
    private route:ActivatedRoute,
    public rest:ApiContentService,
  ) { }

  _id = '';

  ngOnInit() {
    this._id = this.route.snapshot.params.id;
    this.getDataprospek(this._id);
  }

  getDataprospek(_id){
  //   this.rest.getDataprospek(_id).subscribe((response:any) => {
      // console.log(response);
      
      if (_id == 1) {        
        console.log('cover');
      } else {
        console.log('not cover');
      } 
      // else {
      //   console.log('Duplikat');
      // }
    // })
  }
}
